
import Image from "./Image";
import { PRODUCTS } from "./productNavData";
const REVEAL_CLASS = "anchor-reveal";
function revealSection(event, anchor) {
    const target = document.getElementById(anchor);
    if (!target)
        return;
    event.preventDefault();
    // Restart the animation if the same section is clicked twice in a row.
    target.classList.remove(REVEAL_CLASS);
    void target.offsetWidth;
    target.classList.add(REVEAL_CLASS);
    target.addEventListener("animationend", () => target.classList.remove(REVEAL_CLASS), { once: true });
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    window.history.pushState(null, "", `#${anchor}`);
}
/* Each lockup links to its section. On hover/focus a frosted-glass tagline card
   appears above the logo; it's absolutely positioned so revealing it never shifts the row. */
export function HeroProductMarks() {
    return (<ul aria-label="Rentid products" className="grid w-full grid-cols-3 items-end gap-x-3 gap-y-6 sm:flex sm:w-auto sm:flex-wrap sm:gap-7">
      {PRODUCTS.map((product) => (<li key={product.name} className="relative flex min-w-0 justify-center sm:block">
          <a href={`#${product.anchor}`} onClick={(event) => revealSection(event, product.anchor)} aria-describedby={`${product.anchor}-tagline`} className="group flex flex-col items-center rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-white/70">
            <Image src={product.lockup.src || "/placeholder.svg"} alt={product.name} width={product.lockup.width} height={product.lockup.height} className="h-10 w-auto max-w-full object-contain transition-transform duration-300 group-hover:-translate-y-0.5 sm:h-14"/>
            <span id={`${product.anchor}-tagline`} className="pointer-events-none absolute max-sm:sr-only bottom-full left-1/2 z-10 mb-3 -translate-x-1/2 translate-y-1 whitespace-nowrap rounded-xl border border-white/20 bg-white/10 px-3.5 py-2 font-sans text-xs font-medium text-white opacity-0 shadow-lg shadow-black/20 backdrop-blur-md transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100 group-focus-visible:translate-y-0 group-focus-visible:opacity-100">
              {product.tagline}
            </span>
          </a>
        </li>))}
    </ul>);
}
